'use client';

import { Box, Button, Tooltip, TooltipProps, LinkProps } from '@mui/material';
import Link from 'next/link';

export const HyperLink = (props: {
  pathname: string;
  label: string;
  tooltipPlacement?: TooltipProps['placement'];
  linkStyle?: LinkProps['style'];
}) => {
  const { pathname, label, linkStyle } = props;

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <Tooltip
        placement={props.tooltipPlacement ?? 'bottom'}
        title="View Details"
      >
        <Link href={pathname}>
          <Button
            sx={{ borderRadius: 50, ...linkStyle }}
            variant="text"
            size="small"
            color="info"
          >
            {label}
          </Button>
        </Link>
      </Tooltip>
    </Box>
  );
};
